import { render, staticRenderFns } from "./aside.vue?vue&type=template&id=1d772d8c&scoped=true&"
import script from "./aside.vue?vue&type=script&lang=js&"
export * from "./aside.vue?vue&type=script&lang=js&"
import style0 from "./aside.vue?vue&type=style&index=0&id=1d772d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d772d8c",
  null
  
)

export default component.exports